module.exports = __webpack_public_path__ + "media/images/circle-7725d561bb71f04eabf2fdce59d387e9.png";